import {
	AppstoreOutlined,
	CloudServerOutlined,
	CommentOutlined,
	CopyrightOutlined,
	DatabaseOutlined,
	GlobalOutlined,
	HomeOutlined,
	InboxOutlined,
	KeyOutlined,
	LinkOutlined,
	MailOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { ItemType } from 'antd/es/menu/hooks/useItems';
import React from 'react';
import { Link } from 'react-router-dom';

import classes from './Sidebar.module.less';

import useConfig from 'hooks/useConfig';

type Props = {
	isCollapsed: boolean;
};

const Sidebar = ({ isCollapsed }: Props) => {
	const config = useConfig();

	const menuItems: ItemType[] = [
		{
			key: '1',
			icon: <HomeOutlined />,
			label: <Link to="/">Главная</Link>,
		},
		{
			key: '2',
			icon: <CommentOutlined />,
			label: <Link to="/404">Чаты</Link>,
		},
		{
			key: '3',
			icon: <DatabaseOutlined />,
			label: 'Данные движков',
			children: [
				{
					key: '3.1',
					icon: <AppstoreOutlined />,
					label: <Link to="/engines/buys">Модули и шаблоны</Link>,
				},
				{
					key: '3.2',
					icon: <GlobalOutlined />,
					label: <Link to="/engines/ip">Ip</Link>,
				},
				{
					key: '3.3',
					icon: <MailOutlined />,
					label: <Link to="/engines/email">Почта</Link>,
				},
				{
					key: '3.4',
					icon: <LinkOutlined />,
					label: <Link to="/engines/link">Ссылка на скачивание</Link>,
				},
				{
					key: '3.5',
					icon: <InboxOutlined />,
					label: <Link to="/engines/regenerate">Новый билд движка</Link>,
				},
				{
					key: '3.6',
					icon: <CloudServerOutlined />,
					label: <Link to="/engines/monitoring-service-key">Ключ мониторинга</Link>,
				},
				{
					key: '3.7',
					icon: <KeyOutlined />,
					label: <Link to="/engines/md5-key">Ключ md5</Link>,
				},
				{
					key: '3.8',
					icon: <CopyrightOutlined />,
					label: <Link to="/engines/copyright-key">Ключ копирайта</Link>,
				},
			],
		},
	];

	return (
		<Sider trigger={null} collapsible collapsed={isCollapsed} className={classes.container}>
			<div className={classes.logo}>{config.appName}</div>
			<Menu mode="inline" items={menuItems} className={classes.menu} />
		</Sider>
	);
};

export default Sidebar;
